/**
 * Initializes the controls for the video player.
 */
export default function initVideoControls() {
  const playPauseButtons = document.querySelectorAll('.play-pause-button');

  playPauseButtons.forEach((playPauseButton) => {
    const video = playPauseButton.closest('.media').querySelector('video');

    playPauseButton.addEventListener('click', () => {
      const isPlaying = !video.paused;
      playPauseButton.setAttribute('data-is-playing', !isPlaying);
      isPlaying ? video.pause() : video.play();
    });
  });

  updateVideoControlsBasedOnScreenSize();
}

/**
 * Updates the video controls based on the screen size.
 */
function updateVideoControlsBasedOnScreenSize() {
  const mainMenu = document.querySelector(`.main-menu`);
  const mainMenuContent = mainMenu.querySelector('.top-container');
  const heroPlayPauseButton = document.querySelector('.header .play-pause-button');

  if(heroPlayPauseButton) {
    const fontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    const mainMenuHeightRem = mainMenu.offsetHeight / fontSize;
    const mainMenuContentLeftRem = mainMenuContent.offsetLeft / fontSize;
    heroPlayPauseButton.style.top = `${mainMenuHeightRem}rem`;
    heroPlayPauseButton.style.left = `${mainMenuContentLeftRem}rem`;
  }

  if(!window.videoControlsResizeListenerAdded) {
    window.addEventListener('resize', updateVideoControlsBasedOnScreenSize);
    window.videoControlsResizeListenerAdded = true;
  }
}
